import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminAddresses from "./address/AdminAddresses";
import EnquiryList from "./EnquiryList";
import BASE_URL from "../../BASEURL";

export default function ContactCMS() {
  const navigate = useNavigate();
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const res = await fetch(`${BASE_URL}/api/contact/all`);
        const data = await res.json().catch(() => ({}));
        // API may return array or { contacts: [...] }
        const list = Array.isArray(data) ? data : data.contacts || [];
        setContacts(list);
      } catch (err) {
        setError("Failed to load contacts");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="max-w-6xl mx-auto p-1 space-y-6">
        <div className="bg-white p-6 rounded shadow space-y-4">
        <EnquiryList />
      </div>

      <div className="flex justify-between flex-col md:flex-row items-start gap-3 md:items-center">
        <h1 className="text-2xl font-bold text-primary">Contact Page Content</h1>
        <button
          onClick={() => {
            const c = contacts[0];
            const id = c && (c._id || c.id);
            if (id) navigate(`/admin/contact/edit/${id}`);
            else navigate('/admin/contact/edit');
          }}
          className="bg-primary text-white px-6 py-2 rounded disabled:opacity-50 disabled:cursor-not-allowed"
          disabled={loading || contacts.length === 0}
        >
          {loading ? "Loading..." : "Edit"}
        </button>
      </div>

      <div className="bg-white p-6 rounded shadow space-y-4">
        {loading && <p>Loading contact...</p>}
        {error && <p className="text-sm text-red-600">{error}</p>}
        {!loading && !error && contacts.length > 0 && (
          (() => {
            const c = contacts[0];
            return (
              <>
                <p><b>Phone:</b> {c.phone}</p>
                <p><b>Email:</b> {c.email}</p>
                <p><b>Address:</b> {c.address}</p>
                <p><b>Google Map:</b> {c.mapUrl}</p>
              </>
            );
          })()
        )}
        {!loading && !error && contacts.length === 0 && <p>No contact data available</p>}
      </div>

      <AdminAddresses   />
    </div>
  );
}
